<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4 header-row">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Regras Tributárias</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Regras da Reforma Tributária e fórmulas do motor fiscal.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if (selection?.hasValue()) {
                        <span>Ações ({{ selection.selected.length }})</span>
                    } @else {
                        <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="excluirSelecionados()" [disabled]="!podeExcluirSelecionados()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionados</span>
                    </button>
                </mat-menu>
                <button mat-flat-button class="btn-primary" (click)="novaRegra()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Nova Regra
                </button>
            </div>
        </div>

        <mat-tab-group class="main-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true"
            (selectedTabChange)="$event.index === 1 ? onTabFormulasAtivada() : null">

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">rule</mat-icon>
                    <span class="tab-label-text">Regras</span>
                </ng-template>
                <app-regras-lista></app-regras-lista>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">function</mat-icon>
                    <span class="tab-label-text">Fórmulas Padrão</span>
                </ng-template>
                <app-formulas-regra-tributaria-tab
                    [grupos]="_gruposFormulas"
                    [isLoading]="_isLoadingFormulas"
                    (modeloEmpresaSelecionado)="alterarModeloEmpresa($event)">
                </app-formulas-regra-tributaria-tab>
            </mat-tab>

        </mat-tab-group>

    </div>
</div>
